import React, { useEffect, useState, useCallback } from 'react';
import { formatCurrency } from '../../tools/tool';
import { adminServices } from '../../services/AdminServices';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const TotalPadalaCard = ({
  dateRange
}) => {
  const navigate = useNavigate();
  const [totalPadala, setTotalPadala] = useState(0);
  const [walkinPadala, setWalkinPadala] = useState(0);
  const [merchantWalkinPadala, setMerchantWalkinPadala] = useState(0);
  const [icarusApp, setIcarusApp] = useState(0);
  const [ecpay, setEcpay] = useState(0);
  const getTotalPadala = useCallback(async () => {
    try {
      let walkinTotal = 0;
      let icarusTotal = 0;
      let ecpayTotal = 0;
      let walkinMerchantTotal = 0;
      let padalaSP = 'padala_report';
      let params = {};
      if (dateRange.dateFrom && dateRange.dateTo) {
        params = {
          dateFrom: dateRange.dateFrom,
          dateTo: dateRange.dateTo
        };
        padalaSP = 'padala_report_range';
      } else {
        params = {};
      }
      try {
        const padalaResponse = await adminServices.storeProcedure2(padalaSP, params);
        if (padalaResponse.status === 200 && padalaResponse.data && padalaResponse.data.length > 0) {
          const walkinTransactions = padalaResponse.data.filter(item => item.cash_in_from && item.cash_in_from.toLowerCase().includes('walk'));
          walkinTotal = walkinTransactions.reduce((total, item) => total + Math.abs(item.net_amount || 0), 0);
          const icarusTransactions = padalaResponse.data.filter(item => item.cash_in_from && (item.cash_in_from.toLowerCase().includes('padala app') || item.cash_in_from.toLowerCase().includes('app')));
          icarusTotal = icarusTransactions.reduce((total, item) => total + Math.abs(item.net_amount || 0), 0);
          const ecpayTransactions = padalaResponse.data.filter(item => item.cash_in_from && item.cash_in_from.toLowerCase().includes('ecpay'));
          ecpayTotal = ecpayTransactions.reduce((total, item) => total + Math.abs(item.net_amount || 0), 0);
        }
        const merchantPadala = await adminServices.storeProcedure2('merchant_' + padalaSP, params);
        if (merchantPadala.status === 200 && merchantPadala.data && merchantPadala.data.length > 0) {
          walkinMerchantTotal = merchantPadala.data.reduce((total, item) => total + Math.abs(item.net_amount || 0), 0);
        }
        setWalkinPadala(walkinTotal);
        setMerchantWalkinPadala(walkinMerchantTotal);
        setIcarusApp(icarusTotal);
        setEcpay(ecpayTotal);
      } catch (error) {
        setWalkinPadala(0);
        setIcarusApp(0);
        setEcpay(0);
      }
      const total = walkinTotal + walkinMerchantTotal + icarusTotal + ecpayTotal;
      setTotalPadala(total);
    } catch (error) {
      if (error.status === 401) {
        navigate('/');
      }
      if (error.status === 429) {
        toast.error('Too many requests. Data will retry in 1 minute.');
        setTimeout(async () => {
          await getTotalPadala();
        }, 60000);
      }
    }
  }, [navigate, dateRange]);
  useEffect(() => {
    getTotalPadala();
  }, [getTotalPadala, dateRange]);
  return <div className="card" style={{
    width: '100%',
    marginBottom: '20px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  }}>
              <div className="card-header" style={{
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #e0e0e0',
      padding: '15px',
      textAlign: 'center'
    }}>
                <h5 style={{
        margin: 0,
        color: '#333',
        fontWeight: 'bold'
      }}>TOTAL PDL WALLET BALANCE</h5>
                <p style={{
        margin: '5px 0 0 0',
        color: '#666',
        fontSize: '14px'
      }}>
                  Money came from padala or load to PDL & Merchant Wallet (Loading fee is not included)
                </p>
              </div>
      <div className="card-body" style={{
      padding: '20px'
    }}>
        <div style={{
        textAlign: 'center',
        marginBottom: '20px'
      }}>
          <h2 style={{
          fontSize: '2.5rem',
          fontWeight: 'bold',
          color: '#333',
          margin: 0
        }}>
          {formatCurrency(totalPadala || 0)}
          </h2>
        </div>
        
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '15px'
      }}>

                  <div style={{
          flex: 1,
          textAlign: 'center'
        }}>
                    <h6 style={{
            color: '#666',
            marginBottom: '5px'
          }}>Merchant Walk-in Padala</h6>
                    <p style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#333',
            margin: '0 0 10px 0'
          }}>
                      {formatCurrency(merchantWalkinPadala || 0)}
                    </p>
                    <button onClick={() => navigate('/merchant-padala-reports')} style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            fontSize: '12px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }} onMouseOver={e => e.target.style.background = '#0056b3'} onMouseOut={e => e.target.style.background = '#007bff'}>
                      Show Details
                    </button>
                  </div>

                  <div style={{
          flex: 1,
          textAlign: 'center'
        }}>
                    <h6 style={{
            color: '#666',
            marginBottom: '5px'
          }}>Walk-in Padala</h6>
                    <p style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#333',
            margin: '0 0 10px 0'
          }}>
                      {formatCurrency(walkinPadala || 0)}
                    </p>
                    <button onClick={() => navigate('/padala-reports?type=walk-in')} style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            fontSize: '12px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }} onMouseOver={e => e.target.style.background = '#0056b3'} onMouseOut={e => e.target.style.background = '#007bff'}>
                      Show Details
                    </button>
                  </div>
          
          <div style={{
          flex: 1,
          textAlign: 'center'
        }}>
            <h6 style={{
            color: '#666',
            marginBottom: '5px'
          }}>Icarus App</h6>
            <p style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#333',
            margin: '0 0 10px 0'
          }}>
              {formatCurrency(icarusApp || 0)}
            </p>
            <button onClick={() => navigate('/padala-reports?type=icarus')} style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            fontSize: '12px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }} onMouseOver={e => e.target.style.background = '#0056b3'} onMouseOut={e => e.target.style.background = '#007bff'}>
              Show Details
            </button>
          </div>
          
          <div style={{
          flex: 1,
          textAlign: 'center'
        }}>
            <h6 style={{
            color: '#666',
            marginBottom: '5px'
          }}>Ecpay</h6>
            <p style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#333',
            margin: '0 0 10px 0'
          }}>
              {formatCurrency(ecpay || 0)}
            </p>
            <button onClick={() => navigate('/padala-reports?type=ecpay')} style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            fontSize: '12px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }} onMouseOver={e => e.target.style.background = '#0056b3'} onMouseOut={e => e.target.style.background = '#007bff'}>
              Show Details
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default TotalPadalaCard;